import React from "react";

interface AutoLinkTextProps {
  text?: string;
}

const AutoLinkText: React.FC<AutoLinkTextProps> = ({ text = "" }) => {
  const safeText = text || "";
  // Match URLs starting with http(s) or www
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
  const parts = safeText.split(urlRegex);

  return (
    <span>
      {parts.map((part, i) => {
        if (part.match(urlRegex)) {
          const href = part.startsWith("http") ? part : `https://${part}`;
          return (
            <a
              key={i}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#007bff",
                textDecoration: "underline",
                wordBreak: "break-all",
              }}
            >
              {part}
            </a>
          );
        }
        return part;
      })}
    </span>
  );
};

export default AutoLinkText;
